<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center mt-8>
        <!-- Feeds-->

        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center mb-5>
              <v-flex xs12 md8>
                <div class="font-weight-bold defaultColor--text" style="font-size:20px">
                  {{ $t("title.liveStreamArchive") }}
                </div>
                <v-spacer />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer">
                <div
                  id="firstDiagno"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <feed-item-card
                    class="test-diagno mb-5"
                    :itemData="item"
                    :index="index"
                    :postViewShow="true"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import BroadcastService from "../../services/BroadcastService";

export default {
  data: () => {
    return {
      page: 1,
      per_page: 15,
      paginationStop: false,
      items: [],
    };
  },
  components: {
    FeedItemCard,
  },
  methods: {
    getFeedItems() {
      this.loading = true;
      setPageLoading(true);
      BroadcastService.getLiveStreamArchive(this.page, this.per_page)
        .then((res) => {
          const posts = res.data.Result;
          let _data = [];
          if (this.page !== 1) {
            _data = [...this.items, ...posts];
          } else {
            _data = posts;
          }
          if (posts.length == 0) this.paginationStop = true;
          this.items = _data;
        })
        .catch(async (err) => {
          console.log("err : ", err);
          window.showError(err);
        })
        .then(() => {
          this.loading = false;
          setPageLoading(false);
        });
    },

    paginationPage() {
      console.log("paginationPage");
      this.page++;
      this.getFeedItems();
    },

    //Infinite scroll
    scrollTop(e) {
      if (!this.loading) {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          if (!this.paginationStop) this.paginationPage();
        }
      }
    },
  },
  computed: {},
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    this.getFeedItems();
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>
